import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Play } from 'lucide-react';

export const HeroSection = () => {
  return (
    <section className="pt-24 pb-16 bg-gradient-to-br from-[#F7F9FC] via-white to-[#F7F9FC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <h1 className="text-4xl lg:text-6xl font-bold leading-tight md:mt-14">
                <span className="text-[#0A2540]">La solución de</span>
                <br />
                <span className="text-[#5750f1]">Tienda Digital</span>

                <p className="text-[#0A2540] text-3xl mt-1">Especializada en iPhone y Tecnología</p>
              </h1>
              
              <p className="text-xl text-gray-600 leading-relaxed max-w-lg text-balance">
                <p>Si vendes productos Apple u otras marcas, ¡<b>Basta ⛔ de plantillas excel</b> para tus clientes!</p>

                {/* <p>Crea ahora tu tienda digital de iPhone y tecnología en minutos con plantillas inteligentes preparadas. </p> */}

                <p>Dale a tu tienda el <b>Profesionalismo</b> ✅ que se merece y lleva tus <b>Ventas</b> 📊 al siguiente nivel.</p>
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg" 
                onClick={() => window.open('https://panel.digistore.com.ar/auth/sign-up', '_blank')}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#5750f1] hover:bg-[#0042CC] text-white px-8 py-4 text-lg transition-all duration-200 transform hover:scale-105 hover:shadow-lg"
              >
                Comenzar Ahora
                <ArrowRight className="ml-2" size={20} />
              </Button>
              
              <Button 
                onClick={() => window.open('https://demo.digistore.com.ar', '_blank')}
                size="lg" 
                variant="outline" 
                target="_blank"
                rel="noopener noreferrer"
                className="border-[#5750f1] text-[#5750f1] hover:bg-[#5750f1] hover:text-white px-8 py-4 text-lg transition-all duration-200"
              >
                <Play className="mr-2" size={20} />
                Ver Demo
              </Button>
            </div>

            {/* Trust Indicators */}
            {/* <div className="flex items-center space-x-8 pt-4">
              <div className="text-sm text-gray-500">
                <div className="font-semibold text-[#0A2540]">+50</div>
                <div>Plantillas</div>
              </div>
              <div className="text-sm text-gray-500">
                <div className="font-semibold text-[#0A2540]">100%</div>
                <div>Profesionalismo</div>
              </div>
              <div className="text-sm text-gray-500">
                <div className="font-semibold text-[#0A2540]">100%</div>
                <div>Mejora tus ventas</div>
              </div> 
            </div> */}

          </div>

          {/* Right Column - Hero Image */}
          <div className="relative">
            <div className="relative z-10">
              <img
                //src="https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86"
                src="/digistore_shot.png"
                alt="DigiStore Dashboard & Storefront Mockup"
                className="w-full h-auto rounded-2xl shadow-2xl transition-transform duration-500 hover:scale-105"
              />
              
              {/* Floating Elements */}
              <div className="absolute -top-4 -right-4 bg-white rounded-lg shadow-lg p-4 animate-bounce">
                <div className="text-xs text-gray-500">Digital</div>
                <div className="text-lg font-bold text-green-600">100%</div>
              </div>
              
              <div className="absolute -bottom-4 -left-4 bg-white rounded-lg shadow-lg p-4">
                <div className="text-xs text-gray-500">Gratis</div>
                <div className="text-lg font-bold text-[#5750f1]">3 Meses</div>
              </div>
            </div>
            
            {/* Background Decoration */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#5750f1]/20 to-transparent rounded-2xl -z-10 transform rotate-3"></div>
          </div>
        </div>
      </div>
    </section>
  );
};